/*
 * Authors: mariushirjanu
 * Created: 06/04/2018
 * Upgraded: 02/03/2023
 */
import { Injectable } from '@angular/core';
import { HttpDataService, IHttpDataCache } from '../../../shared/http/http-data.service';


export interface IPartConfiguration {
  partConfigurationExist:boolean;
  propertyDefinitionCode:string;
  productDefinitionDescription:string;
  configurationId:number;
  category:string;
  partOptions:IPartConfigurationOption[];
}

export interface IPartConfigurationOption {
  id?:number;
  description:string;
  productCategorySuffix?:string;
}

@Injectable()
export class PartConfiguratorDataService {
  private cache:IHttpDataCache<any>;

  constructor(
    private httpDataService:HttpDataService
  ) {
    this.cache = httpDataService.createCache();
  }

  public getPartConfiguration(partNumber:string, webshopId:number, countryId:number):Promise<IPartConfiguration> {
    return this.cache.doGET(
      'rest/catalog/partconfiguration',
      {
        partNumber,
        webshopId,
        countryId
      },
      undefined,
      'Error getting product configuration'
    );
  }

  public getMoreOptions(countryId:number, configurationId:number, propertyDefinitionCode:string, category:string, partNumber:string):Promise<IPartConfigurationOption[]> {
    return this.cache.doGET(
      'rest/catalog/partconfiguration/moreoptions',
      {
        countryId,
        configurationId,
        propertyDefinitionCode,
        category,
        partNumber
      },
      undefined,
      'Error getting more options'
    );
  }

  public clear() {
    this.cache.clear();
  }
}